






























import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';

import {IpStatus} from '@/model/network/connection/IpStatus';

import PropertyDisplayer from '@/components/Utils/PropertyDisplayer.vue';
import {IpMode} from '@/model/network/IpMode';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {PropertyDisplayer},
})
export default class NetworkIpStatusDisplayHeader extends Mixins<BaseComponent>(BaseComponent) {

  @Prop(Object)
  private ipStatus!: IpStatus | null;

  @Prop(String)
  private mode!: IpMode;

  private IpMode = IpMode;
}
